import controller from './card-delete-dialog.controller';

export default {
  controller,
  template: require('./card-delete-dialog.html')
};



// WEBPACK FOOTER //
// src/app/buy/card-delete-dialog/card-delete-dialog.component.ts